import api from '../utils/api';

// Canonical (nested) style keys a preset stores. The block-level "Add Button"
// uses these keys directly; the other editors (columns/slides/heroes/pricing)
// use flat `button*` keys, so we translate on save/apply.
const NESTED_KEYS = ['style', 'size', 'color', 'textColor', 'gradientColor', 'radius', 'hover', 'icon', 'iconPosition', 'iconColor'];
const FLAT_MAP = {
  style: 'buttonStyle',
  size: 'buttonSize',
  color: 'buttonColor',
  textColor: 'buttonTextColor',
  gradientColor: 'buttonGradientColor',
  radius: 'buttonRadius',
  hover: 'buttonHover',
  icon: 'buttonIcon',
  iconPosition: 'buttonIconPosition',
  iconColor: 'buttonIconColor',
};

export const pickNested = (obj = {}) => {
  const s = {};
  NESTED_KEYS.forEach((k) => { if (obj[k] !== undefined) s[k] = obj[k]; });
  return s;
};

export const flatToNested = (f = {}) => {
  const s = {};
  NESTED_KEYS.forEach((k) => { const fk = FLAT_MAP[k]; if (f[fk] !== undefined) s[k] = f[fk]; });
  return s;
};

export const nestedToFlat = (n = {}) => {
  const out = {};
  NESTED_KEYS.forEach((k) => { if (n[k] !== undefined) out[FLAT_MAP[k]] = n[k]; });
  return out;
};

export const fetchPresets = async () => {
  try {
    const r = await api.get('/button-presets');
    return r.data?.presets || [];
  } catch (e) {
    return [];
  }
};

export const createPreset = (name, style) => api.post('/button-presets', { name, style });
export const removePreset = (id) => api.delete(`/button-presets/${id}`);

// Applied when the user picks "None" — resets the button to a plain default
// (solid, rounded corners, no icon, simple fade hover, default colours).
// "None" preset clears explicit colours so the button inherits the current
// site theme (primary / secondary / link-hover). Only structural defaults
// (variant, size, radius, hover animation) are set.
export const DEFAULT_BUTTON_STYLE = {
  style: 'solid',
  size: 'md',
  color: undefined,
  textColor: undefined,
  gradientColor: undefined,
  radius: 'rounded',
  hover: 'fade',
  icon: 'none',
  iconPosition: 'right',
  iconColor: undefined,
};
